import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SignupStore {
  setNewAccount(newAccount: any) {
    localStorage.setItem('newAccount', JSON.stringify(newAccount));
  }

  getNewAccount() {
    return JSON.parse(localStorage.getItem('newAccount'));
  }

  removeNewAccount() {
    localStorage.removeItem('newAccount');
  }

  setIsAccountNew(isNew: boolean) {
    localStorage.setItem('isAccountNew', isNew.toString());
  }

  getIsAccountNew() {
    return localStorage.getItem('isAccountNew');
  }

  setStates(states: any) {
    localStorage.setItem('states', JSON.stringify(states));
  }

  getStates() {
    return JSON.parse(localStorage.getItem('states'));
  }

  setLgas(lgas: any) {
    localStorage.setItem('lgas', JSON.stringify(lgas));
  }

  getLgas() {
    return JSON.parse(localStorage.getItem('lgas'));
  }

  setName(name: any) {
    localStorage.setItem('name', name);
  }

  getName() {
    return localStorage.getItem('name');
  }

  setBusinessType(businessType: any) {
    localStorage.setItem('businessType', businessType);
  }

  getBusinessType() {
    return localStorage.getItem('businessType');
  }

  setAddress(address: any) {
    localStorage.setItem('address', address);
  }

  getAddress() {
    return localStorage.getItem('address');
  }

  setEmail(email: any) {
    localStorage.setItem('email', email);
  }

  getEmail() {
    return localStorage.getItem('email');
  }

  setPhone(phone: any) {
    localStorage.setItem('phone', phone);
  }

  getPhone() {
    return localStorage.getItem('phone');
  }

  setSelectedState(state: any) {
    localStorage.setItem('state', state);
  }

  getSelectedState() {
    return localStorage.getItem('state');
  }

  setSelectedLga(lga: any) {
    localStorage.setItem('lga', lga);
  }

  getSelectedLga() {
    return localStorage.getItem('lga');
  }

  setSelectedBank(bank: any) {
    localStorage.setItem('bank', bank);
  }

  getSelectedBank() {
    return localStorage.getItem('bank');
  }

  removeSignupItems() {
    localStorage.removeItem('name');
    localStorage.removeItem('businessType');
    localStorage.removeItem('address');
    localStorage.removeItem('email');
    localStorage.removeItem('phone');
    localStorage.removeItem('bank');
    localStorage.removeItem('state');
    localStorage.removeItem('lga');
    localStorage.removeItem('isAccountNew');
    localStorage.removeItem('demoAccountName');
    localStorage.removeItem('referralId');
  }
}
